const FETCH_SEEKER_MESSAGES = 'leads/seekerChat/FETCH_SEEKER_MESSAGES';
const FETCH_SEEKER_MESSAGES_SUCCEEDED = 'leads/seekerChat/FETCH_SEEKER_MESSAGES_SUCCEEDED';
const FETCH_SEEKER_MESSAGES_FAILED = 'leads/seekerChat/FETCH_SEEKER_MESSAGES_FAILED';
const FETCH_SEEKER_MESSAGES_RESET = 'leads/seekerChat/FETCH_SEEKER_MESSAGES_RESET';

const ADD_SEEKER_MESSAGE = 'leads/seekerChat/ADD_SEEKER_MESSAGE';
const ADD_SEEKER_MESSAGE_SUCCEEDED = 'leads/seekerChat/ADD_SEEKER_MESSAGE_SUCCEEDED';

const ADD_FILE = 'leads/seekerChat/ADD_FILE';
const ADD_FILE_SUCCEEDED = 'leads/seekerChat/ADD_FILE_SUCCEEDED';
const REMOVE_FILE = 'leads/seekerChat/REMOVE_FILE';
const RESET_FILES = 'leads/seekerChat/RESET_FILE_SUCCEEDED';
const ERROR_UPLOAD = 'leads/seekerChat/ERROR_UPLOAD';
const SHOW_SNACKBAR = 'leads/seekerChat/SHOW_SNACKBAR';
const HIDE_SNACKBAR = 'leads/seekerChat/HIDE_SNACKBAR';
const REVERT_ERROR = 'leads/seekerChat/REVERT_ERROR';
const SHOW_MODAL = 'leads/seekerChat/SHOW_MODAL';

export {
  ADD_SEEKER_MESSAGE,
  ADD_SEEKER_MESSAGE_SUCCEEDED,
  FETCH_SEEKER_MESSAGES,
  FETCH_SEEKER_MESSAGES_SUCCEEDED,
  FETCH_SEEKER_MESSAGES_FAILED,
  FETCH_SEEKER_MESSAGES_RESET,
  ADD_FILE,
  ADD_FILE_SUCCEEDED,
  REMOVE_FILE,
  RESET_FILES,
  ERROR_UPLOAD,
  SHOW_SNACKBAR,
  HIDE_SNACKBAR,
  REVERT_ERROR,
  SHOW_MODAL
};
